<template>
  <a-page-header :ghost="false" title="数据" :backIcon="false">
    <template slot="extra">
      <a-range-picker
        :ranges="{
          今天: [moment(), moment()],
          本周: [moment().subtract(weekOfday - 1, 'days'), moment()],
          本月: [moment().startOf('month'), moment()],
          本年: [moment().startOf('year'), moment()],
          有史以来: [moment(originDate), moment()]
        }"
        :disabled-date="disabledDate"
        :defaultValue="[moment().subtract(weekOfday - 1, 'days'), moment()]"
        @change="onChange"
      />
      <a-radio-group :value="type" @change="changeTab">
        <a-radio-button value="category">分类</a-radio-button>
        <a-radio-button value="event">事件</a-radio-button>
      </a-radio-group>
    </template>
  </a-page-header>
</template>
<style>
.statistics__filter {
  display: flex;
  align-items: center;
  border-top: 1px solid #e8e8e8;
  height: 5rem;
  padding: 2rem;
}
</style>

<script>
import moment from "moment";
export default {
  props: ["type"],
  data() {
    return {
      weekOfday: moment().format("E")
    };
  },
  computed: {
    originDate() {
      return this.$store.getters.originDate;
    }
  },
  methods: {
    moment,
    onChange(dates, dateStrings) {
      this.$emit("changeInterval", {
        start: moment(dateStrings[0]),
        end: moment(dateStrings[1])
      });
    },
    changeTab(event) {
      this.$emit("changeType", event.target.value);
    },
    disabledDate(current) {
      // console.log(current);
      // Can not select days before today and today
      return current < this.$store.getters.originDate || current > moment();
    }
  }
};
</script>
